import type { LibraryDecision, LibrarySort, LibrarySource, LibraryStage } from '../../lib/library/types';

export const WEB_CONTENT_MAX_WIDTH = 680;

export const STAGE_ORDER: LibraryStage[] = ['inbox', 'screening', 'interview', 'offer', 'talent_pool'];

export const SOURCE_ORDER: LibrarySource[] = ['page', 'email', 'upload', 'scan'];

export const SORT_ORDER: LibrarySort[] = ['newest', 'match_desc', 'name_asc'];

export function stagePalette(stage: LibraryStage) {
  if (stage === 'screening') {
    return {
      bg: 'rgba(94, 41, 255, 0.14)',
      text: '#5E29FF',
    };
  }

  if (stage === 'interview') {
    return {
      bg: 'rgba(16, 185, 129, 0.16)',
      text: '#059669',
    };
  }

  if (stage === 'offer') {
    return {
      bg: 'rgba(249, 115, 22, 0.16)',
      text: '#EA580C',
    };
  }

  if (stage === 'talent_pool') {
    return {
      bg: 'rgba(71, 85, 105, 0.14)',
      text: '#475569',
    };
  }

  return {
    bg: 'rgba(107, 114, 128, 0.14)',
    text: '#6B7280',
  };
}

export function decisionPalette(decision: LibraryDecision) {
  if (decision === 'shortlisted') {
    return {
      bg: 'rgba(16, 185, 129, 0.15)',
      text: '#047857',
    };
  }

  if (decision === 'rejected') {
    return {
      bg: 'rgba(239, 68, 68, 0.14)',
      text: '#DC2626',
    };
  }

  return null;
}
